import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './claims.scss';
import notify from 'devextreme/ui/notify';
import Form, { Item, GroupItem, Label, ButtonItem, ButtonOptions, RequiredRule } from 'devextreme-react/form';
import { Button, Lookup, TextBox, LoadPanel, Popup } from 'devextreme-react';
import service from '../../data/data.js';
import GlobalParams from '../../helpers/GlobalParams.js';
import NewClaim from '../NewClaim/NewClaim.js';
import {
  DataGrid,
  Column,
  Export
} from 'devextreme-react/data-grid';
import ApiHelper from '../../helpers/ApiHelper.js';
import MembersGrid from '../MembersGrid/MembersGrid.js';
import ExcelJs from 'exceljs';
import saveAs  from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';


const Claims = () => {
  const navigate = useNavigate();  // Get the history object from useHistory()
  const [isLoaded, setIsLoaded] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [membersData, setMembersData] = useState(false);

  useEffect(() => {
    let tmpSchemeStore = [];
    if (GlobalParams.schemeStore && GlobalParams.schemeStore.length > 0) {
      tmpSchemeStore = GlobalParams.schemeStore;//GlobalParams.schemeStore.filter(scheme => (scheme.StatusCode === "001"));
    }

    if (tmpSchemeStore.length > 0) {
      console.log(tmpSchemeStore);
    } else {
      notify(`You don't have an active scheme to Request for a Claim`, 'error', 5000);
    }
    //fetchParamsData();
  }, []);


  const fetchParamsData = async () => {
    try {
      //fetchParams();
    } catch (error) {
      // Handle error, e.g., show an error message
      console.error(error);
    }
  }
  const fetchParams = async () => {

    // await GlobalParams.fetchParams({
    //   param: 'scheme-riders',
    //   property: 'AllRiders',
    // });

    //fetch schemes for the logged in person.....

    // await GlobalParams.fetchParams({
    //   param: 'contact-allowed-person-schemes?contact_person_id=' + GlobalParams.ContactPersonId,
    //   property: 'schemeStore',
    // });

    // if (GlobalParams.schemeStore.length === 1) {
    //   GlobalParams.defaultSchemeId = GlobalParams.schemeStore[0]["schemeID"];

    //   // //schemeCategoriesStore
    //   // await GlobalParams.fetchParams({
    //   //   param: 'scheme-categories?scheme_id=' + GlobalParams.defaultSchemeId,
    //   //   property: 'schemeCategoriesStore',
    //   // });
    // }

    // //
    // await GlobalParams.fetchParams({
    //   param: 'get-predefined-subjects',
    //   property: 'EnquiriesSubjects',
    // });

    // await GlobalParams.fetchParams({
    //   param: 'occupation-classes',
    //   property: 'OccupationClasses',
    // });
    // await GlobalParams.fetchParams({
    //   param: 'identity-types',
    //   property: 'IdentityTypes',
    // });
    // await GlobalParams.fetchParams({
    //   param: 'nature-of-business',
    //   property: 'NatureOfBusiness',
    // });
    // await GlobalParams.fetchParams({
    //   param: 'access-types',
    //   property: 'AccessTypes',
    // });
    // await GlobalParams.fetchParams({
    //   param: 'political-status',
    //   property: 'PoliticalStatus',
    // });
    // await GlobalParams.fetchParams({
    //   param: 'product-classes',
    //   property: 'ProductClasses',
    // });
    // await GlobalParams.fetchParams({
    //   param: 'uw-decisions',
    //   property: 'MedicalUwDecision',
    // });
    
    await GlobalParams.fetchParams({
      param: 'claim-types',
      property: 'ClaimTpyes',
    });  
    await GlobalParams.fetchParams({
      param: 'claim-causes',
      property: 'ClaimCauses',
    });
    await GlobalParams.fetchParams({
      param: 'get-banks',
      property: 'Banks',
    });
    await GlobalParams.fetchParams({
      param: 'get-payment-methods',
      property: 'PaymentMethods',
    });
    await GlobalParams.fetchParams({
      param: 'get-bank-branches-codes',
      property: 'BankBranches',
    });
    await GlobalParams.fetchParams({
      param: 'get-statuses',
      property: 'StatusesStore',
    });
    
    // await GlobalParams.fetchParams({
    //   param: 'esg-status',
    //   property: 'ESGStatus',
    // });
    // await GlobalParams.fetchParams({
    //   param: 'ufaa-dormancy-status',
    //   property: 'UFAADormancyStatus',
    // });
    // await GlobalParams.fetchParams({
    //   param: 'slams-preset-countries',
    //   property: 'Countries',
    // });
    // await GlobalParams.fetchParams({
    //   param: 'counties',
    //   property: 'Counties',
    // });
    
    //setIsLoaded(true);
  }



  console.log(GlobalParams.ClaimTpyes);
  var claimTypeOptions = {
    dataSource: GlobalParams.ClaimTpyes, valueExpr: 'claim_type', displayExpr: 'Description'
  }

  const navigateToMembers = () => {
    const dataToSend = 'Data from Claims component';  // Replace this with your actual data
    navigate('/members', { state: { data: dataToSend } });
  };

  const [claimsData, setData] = useState(null);
  const fetchData = async (scheme_id, name) => {
    try {
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + "all-claims-on-scheme?scheme_id=" + scheme_id + "&name=" + name,
        GlobalParams.bearerToken
      );
      console.log(result.data);
      setData(result.data);
    } catch (error) {
      // Handle error, e.g., show an error message
      console.log(error);
    } finally {
      // Set isLoading to false after renderPdfViewer completes
      setIsLoading(false);
    }
  };

  //////search form//////
  const [searchStore, setSearchStore] = useState({
    scheme_id: null,
    name: '',
  });

  const validateForm = (e) => {
    // Implement your validation logic here
    console.log('Form content is ready:', e);
  };

  const productEditorOptions = {
    dataSource: GlobalParams.ProductClasses,
    displayExpr: 'Description',
    valueExpr: 'class_code',
    searchEnabled: false
  };

  const nameEditorOptions = {
    // Add any specific editor options for the 'name' field
  };

  const LabelTemplate = (fieldName) => {
    // Implement your custom label template logic
    return (
      <div>
        <div>{fieldName}</div>
        {/* Add any additional label content or styles */}
      </div>
    );
  };

  const onProductValueChanged = (e) => {
    setSearchStore({ ...searchStore, scheme_id: e.value });
  };

  const onNameValueChanged = (e) => {
    setSearchStore({ ...searchStore, name: e.value });
  };


  const doSearch = useCallback(async (e) => {
    e.preventDefault();
    //TODO perform the search here
    console.log('Search clicked. Scheme:', searchStore.scheme_id);
    setIsLoading(true);
    //fetchData(searchStore.scheme_id, searchStore.name);
    fetchData(searchStore.scheme_id, searchStore.name);
  },
    [searchStore]);
  /////end of search form///

  /////////popup functions//////
  const [popupVisible, setPopupVisible] = useState(false);

  const showPopup = () => {
    setPopupVisible(true);
  };

  const hidePopup = () => {
    setPopupVisible(false);
  };
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  const handleResize = () => {
    setScreenWidth(window.innerWidth);
    setScreenHeight(window.innerHeight);
  };
  ////////end of popup functions//
  const fetchMembers = async (scheme_id, name) => {
    try {
      const result = await ApiHelper.fetchData(
        GlobalParams.ApiUrlPrefix + "search-members?scheme_id=" + scheme_id + "&name=" + name,
        GlobalParams.bearerToken
      );
      setIsLoading(false);
      setMembersData(result.data);
      setPopupMembersGridVisible(true);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify("No members found", 'error', 5000);
    }
  };
  var schemesStore = GlobalParams.schemeStore;
  const doClaimsSearch = useCallback(async (e) => {
    e.preventDefault();
    //TODO perform the search here
    console.log('Search clicked. Scheme:', searchStore.scheme_id);
    setIsLoading(true);
    fetchMembers(searchStore.scheme_id, searchStore.name);
  }, []);

  const [popupMemberSrchVisible, setPopupMemberSrchVisible] = useState(false);
  const showMemberSrchPopup = () => {
    setPopupMemberSrchVisible(true);
  }
  const hideMemberSrchPopup = () => {
    setPopupMemberSrchVisible(false);
  }

  const [popupMembersGridVisible, setPopupMembersGridVisible] = useState(false);
  const showMembersGridPopup = () => {    
    setPopupMembersGridVisible(true);
  }
  const hideMembersGridPopup = () => {
    setPopupMembersGridVisible(false);
  }

  if (!isLoaded) {
    return <LoadPanel visible={true} />;
  }

  const onExporting = (e) => {
    const workbook = new ExcelJs.Workbook();  // ExcelJS should be imported
    const worksheet = workbook.addWorksheet('Main sheet');

    exportDataGrid({
        component: e.component,
        worksheet: worksheet,
        customizeCell: function(options) {
            options.excelCell.font = { name: 'Arial', size: 12 };
            options.excelCell.alignment = { horizontal: 'left' };
        }
    }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
        });
    });
  }


  return (
    <div>

      {/*<div>
        <Popup
          visible={popupVisible}
          onHiding={hidePopup}
          title="REQUEST A NEW CLAIM"

        >
          <NewClaim onClosePopup={hidePopup} />
        </Popup>
      </div>*/
      }
      <div>
        <Popup
          visible={popupMembersGridVisible}
          onHiding={hideMembersGridPopup}
          title="MEMBERS"
        >
          <MembersGrid
            membersData={membersData}
            vsClaims={true} />
        </Popup>
      </div>
      {/*A Member search pop up */}
      <div>
        <Popup
          visible={popupMemberSrchVisible}
          onHiding={hideMemberSrchPopup}
          title="SEARCH MEMBER"

        >
          <div>
            <form onSubmit={doClaimsSearch}>
              <Form
                formData={searchStore}>
                <GroupItem colCount={1} caption="Member Search">
                  <Item
                    dataField="scheme_id"
                    editorType="dxLookup"
                    editorOptions={
                      {
                        dataSource: GlobalParams.schemeStore,
                        displayExpr: "PolicyCompany",
                        valueExpr: "schemeID",
                        searchEnabled: true,
                        onValueChanged: { onProductValueChanged }
                      }
                    }
                  >
                    <RequiredRule message="Scheme is required" />
                    <Label text='Scheme' />
                  </Item>

                  <Item
                    dataField="name"
                    editorType="dxTextBox"
                    editorOptions={
                      {
                        onValueChanged: { onNameValueChanged }
                      }
                    }
                  >
                    <RequiredRule message="Name / Staff No is required" />
                    <Label text='Name / Staff No' />
                  </Item>

                  <ButtonItem
                    horizontalAlignment='left'
                  >
                    <ButtonOptions
                      horizontalAlignment='left'
                      type='default'
                      text="Search"
                      icon='search'
                      useSubmitBehavior={true} />
                  </ButtonItem>
                </GroupItem>
              </Form>
            </form>
            {/*Display the data grid here */}


          </div>
        </Popup>
      </div>
      {isLoading && <LoadPanel visible={true} />}
      <br />
      <div>
        <Button
          type='danger'
          text="Request a New Claim"
          onClick={() => {
            if(GlobalParams.schemeStore && GlobalParams.schemeStore.length > 0){
              setPopupMemberSrchVisible(true);
            }else{
              notify(`You don't have an active scheme to Add Request a New Claim`, 'error', 5000);
            }
          }}
        />
      </div>
      <br />
      <form onSubmit={doSearch}>
        <Form onContentReady={validateForm}
          formData={searchStore} colCount={2}>
          {/*<GroupItem colCount={3} caption="Search Details">*/}
            <Item
              dataField="scheme_id"
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.schemeStore,
                  displayExpr: "PolicyCompany",
                  valueExpr: "schemeID",
                  searchEnabled: true,
                  onValueChanged: { onProductValueChanged }
                }
              }
            >
              <RequiredRule message="Scheme is required" />
              <Label text='Scheme' />
            </Item>

            <Item
              dataField="name"
              editorType="dxTextBox"
              visible={false}
              editorOptions={
                {
                  onValueChanged: { onNameValueChanged },
                  width:400
                }
              }
            >
              <RequiredRule message="Name is required" />
              <Label text='Name' />
            </Item>

            <ButtonItem horizontalAlignment='left'>
              <ButtonOptions
                horizontalAlignment='left'
                type='default'
                text="Search"
                icon='search'
                useSubmitBehavior={true} />
            </ButtonItem>
          
        </Form>
      </form>
      <br></br>
      <div><DataGrid
        dataSource={claimsData}
        allowColumnReordering={true}
        wordWrapEnabled={true}
        searchPanel={
          {
            visible: true,
            width: 250
          }
        }
        headerFilter={{ visible: true }}
        filterRow={
          {
            visible: true,
            applyFilter: 'auto',
          }
        }
        export={{
          allowExportSelectedData: false,
          enabled: true,
          texts: {
            exportAll: 'Export all data',
            // exportSelectedRows: 'Export selected rows'
          }
        }}
        onExporting={onExporting}
      >
        <Column dataField="Names"></Column>
        <Column dataField="Emp_code" ></Column>
        <Column dataField="claim_type" caption='Claim Type' lookup={claimTypeOptions}></Column>
        <Column dataField="claim_no" visible={false}></Column>
        <Column
          dataField="notification_date"
          dataType="date">
        </Column>
        <Column
          dataField="pay_due_date"
          dataType="date">
        </Column>
        <Column dataField="claim_status" caption='Status' >
        </Column >
        <Column dataField="statusCode" visible={false}
          lookup={
            { dataSource: GlobalParams.StatusesStore, valueExpr: 'status_code', displayExpr: 'Description' }}
        />
        <Column dataField="total_proceeds" cellRender={(cellInfo) => {
                          const formattedAmount = parseFloat(cellInfo.data.total_proceeds).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                          return (
                            <span>{formattedAmount}</span>
                          );
                        }}></Column>
        <Column dataField="total_deductions"  cellRender={(cellInfo) => {
                          const formattedAmount = parseFloat(cellInfo.data.total_deductions).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                          return (
                            <span>{formattedAmount}</span>
                          );
                        }}/>
        <Column dataField="net_payment" cellRender={(cellInfo) => {
                          const formattedAmount = parseFloat(cellInfo.data.net_payment).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                          return (
                            <span>{formattedAmount}</span>
                          );
                        }}/>
      </DataGrid></div>
    </div>
  );
}

export default Claims;
